import styled from 'styled-components';
import ArrowRightSvg from './arrow-right.svg';

const ArrowRightIcon = styled(ArrowRightSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.goBrand.blue};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default ArrowRightIcon;
